import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const BreadCrumb = ({ location, activeKey }) => {
  return (
    <Breadcrumb>
      {location.map((data) => (
        <Breadcrumb.Item key={data.label}>
          {data.url ? (
            <Link to={{ 
              pathname: data.url, 
              search: `${data.search ? data.search : ''}${activeKey ? `${data.search ? '&' : '?'}activeKey=${activeKey}` : ''}`
            }}>
              {data.label}
            </Link>
          ) : (
            data.label
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default BreadCrumb;
